// MODIFICHE SU MOUSELEAVE
function initMegamenu() {
    $(".dropdown").on({
        mouseenter: function () {
            $(this).removeClass('open');
            $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true, false).slideDown("400");
            $(this).addClass('open');
        },
        mouseleave: function () {
            $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true, false).slideUp("80");
            $(this).removeClass('open');
        }
    });
}

function destroyMegamenu() {
    $('.dropdown').off('mouseenter mouseleave');
    $('.dropdown-menu.mega-dropdown-menu').removeAttr('style');
}



export {initMegamenu, destroyMegamenu};
